import { Database, Search, AlertCircle, Eye, Lock, Globe } from 'lucide-react';
import { MainBodyData, KeyTakeawaysData } from './types';

export const darkintContent: MainBodyData = {
  number: '06',
  title: 'Darknet Intelligence (DARKINT)',
  icon: Globe,
  sections: {
    overview: "Darknet Intelligence (DARKINT) refers to gathering information from hidden internet forums, marketplaces, and communities accessible through encrypted networks like Tor. This involves monitoring dark web forums, leak databases, and discussion boards to identify threats, leaked data, and emerging information.",
    note: "Accessing dark web content may violate laws in some jurisdictions. Only conduct DARKINT research with proper authorization and legal compliance. Do not engage in any illegal marketplace transactions.",
    steps: [
      { title: "Setup Secure Access", description: "Configure Tor Browser or VPN for anonymized dark web access" },
      { title: "Identify Forums & Platforms", description: "Locate relevant dark web forums, marketplaces, and communities through OSINT indexing" },
      { title: "Monitor Leak Databases", description: "Search and monitor data leak repositories and pastebins for exposed information" },
      { title: "Analyze Threat Intelligence", description: "Identify and catalog emerging threats, exploit discussions, and malware distribution" },
      { title: "Establish Intelligence Pipeline", description: "Create monitoring alerts and establish ongoing threat intelligence collection" },
    ],
    platforms: ["Tor Hidden Services", "Dark Web Forums", "Paste Repositories", "Marketplace Archives", "OnionScan Results", "Dark Web News Sites"],
    dataPoints: [
      "Forum registrations and user activity patterns",
      "Leaked database mentions and data breach details",
      "Exploit availability and pricing information",
      "Threat actor communications and activities",
      "Marketplace trends and illicit trading patterns",
      "Emerging malware and vulnerability discussions"
    ]
  }
};

export const darkintTakeaways: KeyTakeawaysData = {
  sectionTitle: "DARKINT",
  takeaways: [
    "Use multiple data collection methods to corroborate intelligence from dark web sources",
    "Dark web information is often unreliable - always verify through secondary sources",
    "Maintain anonymity and operational security while researching dark web content",
    "Document screenshots and archives immediately as pages can disappear quickly",
    "Avoid direct engagement or purchases - strictly observe and collect information",
    "Ensure all activities comply with local laws and organizational policies"
  ],
  tools: [
    { name: "Tor Browser", category: "DARK WEB ACCESS", description: "Official encrypted browser for accessing hidden Tor services", url: "torproject.org", icon: Lock },
    { name: "OnionScan", category: "DARK WEB CRAWLER", description: "Automated scanning and indexing of Tor hidden services", url: "onionscan.org", icon: Search },
    { name: "DarkSearch", category: "DARK WEB SEARCH", description: "Search engine for dark web content and hidden services", url: "darksearch.io", icon: Search },
    { name: "Pastebin/Dump Sites", category: "LEAK AGGREGATION", description: "Monitor and search public paste repositories for leaked data", url: "pastebin.com", icon: Database },
    { name: "Shodan Darknet", category: "THREAT INTEL", description: "Shodan's dark web indexing for threat identification", url: "shodan.io", icon: Eye },
    { name: "Hunchly", category: "MONITORING", description: "Monitor dark web for brand mentions, threats, and leaks", url: "hunch.ly", icon: AlertCircle }
  ]
};

